/**
 * /channel-partner/hub — layout for the Channel Partner Hub. Gated on
 * `/me.can_access_hub` (see ChannelPartnerHubLayout).
 */
import { createFileRoute } from '@tanstack/react-router';
import { ChannelPartnerHubLayout } from '@/features/channel-partner/components/hub-layout';

export const Route = createFileRoute('/_protected/channel-partner/hub')({
  component: ChannelPartnerHubLayout,
});
